import {AnalyticsEvent} from 'analytics/Analytics';
import {ACTION_CATEGORY, ANALYTICS_MODULE} from 'analytics/AnalyticsTypes';

export const ACCEPTED_UNIT_CONVERSION: AnalyticsEvent = {
  module: ANALYTICS_MODULE.UNITS,
  action: 'accepted_unit_conversion',
  actionCategory: ACTION_CATEGORY.READ,
};
